import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UsersOverviewComponent } from './overview/overview/users-overview.component';
import { UserLayoutComponent } from './overview/layout/users-layout.component';
import { UserSidePanelComponent } from './overview/sidepanel/users-sidepanel.component';
import { UserService } from 'app/shared/services/user.service';
import { SharedModule } from 'app/shared/shared.module';
import { UserDetailsComponent } from 'app/users/detail/user-details.component';
import { UsersNavigatorHelper } from 'app/users/users-navigator-helper';
import { UserFacade } from 'app/shared/services/facades/user.facade';
import { UserEntityResolver } from '../shared/components/entity-resolvers/user.entity-resolver';
import { UserDetailsGeneralComponent } from 'app/users/detail/user-details-general.component';
import { UserDetailsRolesComponent } from 'app/users/detail/user-details-roles.component';
import { UserDetailsRolesApplicationComponent } from 'app/users/detail/user-details-roles-application.component';
import { ReactiveFormsModule } from '@angular/forms';
import { UserDetailsLicensesComponent } from 'app/users/detail/user-details-licenses.component';
import { UserDetailsPermissionsApplicationComponent } from 'app/users/detail/user-details-permissions-application.component';
import { UserDetailsPermissionsComponent } from 'app/users/detail/user-details-permissions.component';
import { CurrentUserEntityResolver } from '../shared/components/entity-resolvers/current-user.entity-resolver';
import { UsersRoutingModule } from './users-routing.module';
import { TextMaskModule } from 'angular2-text-mask';
import { ImportComponent } from './overview/import.component';
import { DownloadImportTemplateComponent } from './overview/download-import-template.component';

@NgModule({
  declarations: [
    UsersOverviewComponent,
    UserLayoutComponent,
    UserSidePanelComponent,
    UserDetailsComponent,
    UserDetailsGeneralComponent,
    UserDetailsRolesComponent,
    UserDetailsRolesApplicationComponent,
    UserDetailsLicensesComponent,
    UserDetailsPermissionsComponent,
    UserDetailsPermissionsApplicationComponent,
    ImportComponent,
    DownloadImportTemplateComponent,
  ],
  imports: [CommonModule, SharedModule, ReactiveFormsModule, FormsModule, UsersRoutingModule, TextMaskModule],
  exports: [
    UsersOverviewComponent,
    UserLayoutComponent,
    UserSidePanelComponent,
    UserDetailsComponent,
    UserDetailsGeneralComponent,
    UserDetailsRolesComponent,
    UserDetailsRolesApplicationComponent,
    UserDetailsLicensesComponent,
    UserDetailsPermissionsComponent,
    UserDetailsPermissionsApplicationComponent,
  ],
  providers: [UserService, UsersNavigatorHelper, UserFacade, UserEntityResolver, CurrentUserEntityResolver],
})
export class UsersModule {}
